module.exports = __webpack_public_path__ + "media/Part1.774be2ad.mp4";